/**
 * The counts payload in the shape CardGridLayout renders: counts in place of
 * observations (empty arrays keep the shared components' "nothing to draw"
 * paths). Empty nodes drop. Used by the Topics page and by any surface that
 * renders one topic's drilldown off a counts payload (the Overview's topic
 * sidebar).
 */
export const toCardTree = (counts) => {
  if (!counts) return null;
  return {
    ...counts,
    tree: (counts.tree || [])
      .filter((topic) => topic.annotationCount > 0)
      .map((topic) => ({
        signalCategoryCounts: {},
        datasets: [],
        ...topic,
        observations: [],
        parkedObservations: [],
        children: (topic.children || [])
          .filter((sub) => sub.annotationCount > 0)
          .map((sub) => ({ signalCategoryCounts: {}, datasets: [], signalId: null, ...sub, observations: [] })),
      })),
  };
};
